import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { getCart } from '../services/commerce';

/** Keeps cart line count in sync with route changes and `v2-cart-changed` events. */
export function useCartItemCount() {
  const { pathname } = useLocation();
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    const cart = await getCart();
    setCount(Number(cart.totalCount) || 0);
  }, []);

  useEffect(() => {
    refresh();
  }, [pathname, refresh]);

  useEffect(() => {
    window.addEventListener('v2-cart-changed', refresh);
    return () => window.removeEventListener('v2-cart-changed', refresh);
  }, [refresh]);

  return count;
}
